import { z } from "zod";

const validateMovel = (x: string | null) => {
  if (x === null) return true;
  const requiredFullSize = 'xxxxxxxxxxx'.length;
  const normalized = x.replaceAll(/\D/g, '');
  return normalized.length === 0 || normalized.length === requiredFullSize;
}

const validateFixo = (x: string | null) => {
  if (x === null) return true;
  const requiredFullSize = 'xxxxxxxxxx'.length;
  const normalized = x.replaceAll(/\D/g, '');
  return normalized.length === 0 || normalized.length === requiredFullSize;
}
//AuditoriaAauditoresSchema

export const AuditoriaAauditoresSchema = z.object({
  Nome: z.string().nullable().optional(),
  TelFixo:  z.string().nullable().default(null).refine(validateFixo, 'Telefone invalido!'),
  TelCelular:  z.string().nullable().default(null).refine(validateMovel, 'Telefone invalido!'),
  Email: z.string().nullable().optional(),
  OutrasInformacoes: z.string().nullable().optional(),
  Cidade: z.string().nullable().optional(),
  Arquivo1: z.instanceof(File).nullable().optional(),
  Arquivo2: z.instanceof(File).nullable().optional(),
  Arquivo3: z.instanceof(File).nullable().optional(),
  Arquivo4: z.instanceof(File).nullable().optional(),
  Arquivo5: z.instanceof(File).nullable().optional(),
  nomeArquivo1: z.string().nullable().optional(),
  nomeArquivo2: z.string().nullable().optional(),
  nomeArquivo3: z.string().nullable().optional(),
  nomeArquivo4: z.string().nullable().optional(),
  nomeArquivo5: z.string().nullable().optional(),
  TipoAuditor: z.number().nullable().optional(),

  //Extra front
  download1: z.string().nullable().optional(),
  download2: z.string().nullable().optional(),
  download3: z.string().nullable().optional(),
  download4: z.string().nullable().optional(),
  download5: z.string().nullable().optional(),
  limparArquivo1: z.boolean().default(false),
  limparArquivo2: z.boolean().default(false),
  limparArquivo3: z.boolean().default(false),
  limparArquivo4: z.boolean().default(false),
  limparArquivo5: z.boolean().default(false),
});

// AuditoriaAauditoresForm

export type AuditoriaAauditoresForm = z.infer<typeof AuditoriaAauditoresSchema>;